const dateFnsLocaleMap = {
  en: () => import("date-fns/locale/en-GB"),
  "en-GB": () => import("date-fns/locale/en-GB"),
  "en-US": () => import("date-fns/locale/en-US"),
  it: () => import("date-fns/locale/it"),
  nl: () => import("date-fns/locale/nl"),
  pt: () => import("date-fns/locale/pt"),
  sv: () => import("date-fns/locale/sv"),
  da: () => import("date-fns/locale/da"),
  fr: () => import("date-fns/locale/fr"),
  es: () => import("date-fns/locale/es"),
  ca: () => import("date-fns/locale/ca"),
  "de-DE": () => import("date-fns/locale/de"),
  "de-AT": () => import("date-fns/locale/de")
};
function getDateFnsLocaleModule(locale) {
  if (dateFnsLocaleMap[locale]) {
    return dateFnsLocaleMap[locale]();
  }
  const language = locale.substr(0, 2);
  if (dateFnsLocaleMap[language]) {
    return dateFnsLocaleMap[language]();
  }
  return void 0;
}
export {
  dateFnsLocaleMap,
  getDateFnsLocaleModule
};
//# sourceMappingURL=date-fns-locales.js.map
